module.exports = __webpack_public_path__ + "img/six.fce86fd6.jpg";